import { render, staticRenderFns } from "./PastProjectForm.vue?vue&type=template&id=0de15148&"
import script from "./PastProjectForm.vue?vue&type=script&lang=ts&"
export * from "./PastProjectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de15148')) {
      api.createRecord('0de15148', component.options)
    } else {
      api.reload('0de15148', component.options)
    }
    module.hot.accept("./PastProjectForm.vue?vue&type=template&id=0de15148&", function () {
      api.rerender('0de15148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/past-projects/PastProjectForm.vue"
export default component.exports